import React from 'react';
import { useLocalize } from '@saviynt/common';
import { Button, ModalIsland } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { msgs } from '../../../utilities/messages';

/**
 * Warning ModalIsland that confirms deletion of a single access key.
 */
function DeleteKeyModal({ isOpen, isDeleting, onConfirm, onCancel }) {
  const localize = useLocalize();

  return (
    <ModalIsland
      kind='warning'
      isOpen={isOpen}
      isCloseButtonVisible={!isDeleting}
      onClose={onCancel}
      alertTitle={localize(msgs.pam.apiKeys.deleteKeyConfirm)}
      primaryButton={
        <Button
          type='button'
          kind='outlined'
          size='medium'
          isLoading={isDeleting}
          loaderText={localize(msgs.pam.apiKeys.attemptingDelete)}
          onClick={onConfirm}>
          {localize(msgs.pam.apiKeys.deleteKeyButton)}
        </Button>
      }
      secondaryButton={
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={isDeleting}
          onClick={onCancel}>
          {localize(msgs.pam.common.cancel)}
        </Button>
      }
    />
  );
}

DeleteKeyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DeleteKeyModal;
